import { CircularProgressCenter, CMSView, useNavigationController } from "@firecms/core";
import { Navigate } from "react-router-dom";

/**
 * A drawer entry that opens a page's edit form directly, skipping the one-row
 * list view. The collection stays registered (it defines the schema and route)
 * but is hidden from navigation.
 */
function PageRedirect({
  collectionId,
  entityId,
}: {
  collectionId: string;
  entityId: string;
}) {
  const navigation = useNavigationController();

  // Wait for the routes to exist before jumping at one of them.
  if (!navigation.initialised) return <CircularProgressCenter />;

  // The prefix depends on `baseCollectionPath`, so ask the controller.
  const target = navigation.buildUrlCollectionPath(`${collectionId}/${entityId}`);

  // `buildUrlCollectionPath` returns no leading slash, which <Navigate> would
  // resolve relative to the current route.
  const absolute = target.startsWith("/") ? target : `/${target}`;

  return <Navigate to={absolute} replace />;
}

export function pageShortcut({
  path,
  name,
  icon,
  group = "Pages",
  description,
  collectionId,
  entityId,
}: {
  /** Where this entry lives in the CMS URL space, e.g. "about-me". */
  path: string;
  name: string;
  icon?: string;
  group?: string;
  description?: string;
  /** The `id` of the page collection, e.g. "page-about". */
  collectionId: string;
  /** The document id inside `pages`, e.g. "about". */
  entityId: string;
}): CMSView {
  return {
    path,
    name,
    icon,
    group,
    description,
    view: <PageRedirect collectionId={collectionId} entityId={entityId} />,
  };
}
